import styled from "styled-components";
import {
  ChevronLeftOutlined,
  ChevronRightOutlined,
} from "../materialUi/materialUi";
import { colors } from "../../styles/figmaColors";
import { TextCapitalized } from "./text/TextCapitalized";

type NavigationArrowsProps = {
  title: string;
  onPrevious: () => void;
  onNext: () => void;
};

export const ChevronTripsDetailsAction = (props: { icon: JSX.Element }) => {
  return <StyledChevronRow>{props.icon}</StyledChevronRow>;
};

export const NavigationArrows = (props: NavigationArrowsProps) => {
  return (
    <StyledNavigationArrows>
      <ChevronTripsDetailsAction
        icon={<ChevronLeftOutlined onClick={() => props.onPrevious()} />}
      />
      <StyledTitle>
        <TextCapitalized>{props.title}</TextCapitalized>
      </StyledTitle>
      <ChevronTripsDetailsAction
        icon={<ChevronRightOutlined onClick={() => props.onNext()} />}
      />
    </StyledNavigationArrows>
  );
};

const StyledNavigationArrows = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitle = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;

const StyledChevronRow = styled.div`
  height: 100%;
  cursor: pointer;
  & svg {
    fill: ${colors["colors/text/darkGrey"]};
    width: 1.25rem;
    height: 1.25rem;
  }
`;
